import React, {useEffect, useState, memo, useRef} from 'react';
import DraggableTileGrid from '../DraggableTileGrid/DraggableTileGrid';
import SongCard from '../SongCard/SongCard';
import SkeletonCard from '../SkeletonCard/SkeletonCard';
import {isMobile} from 'react-device-detect';
import './SongsTile.scss';
import {setPopUp} from '../../FuntoneSlice';
// Component to handle image loading detection
const SongCardWithImageLoading = ({song, onDownload, skeletonWidth, skeletonHeight}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    if (!song.image) {
      setImageLoaded(true);
      return;
    }

    const img = new Image();
    img.onload = () => mountedRef.current && setImageLoaded(true);
    img.onerror = () => mountedRef.current && setImageLoaded(true);
    img.src = song.image;

    return () => {
      mountedRef.current = false;
    };
  }, [song.image]);

  if (!imageLoaded && song.image) return <SkeletonCard variant='song' width={skeletonWidth} height={skeletonHeight} />;
  return <SongCard song={song} onDownload={onDownload} inTileView={true} />;
};

const SongsTile = ({
  songs = [],
  onSongClick = () => {},
  onDownload = undefined,
  title = '',
  viewAllText = 'לכל השירים',
  onViewAllClick = () => {},
  isLoading = false,
  skeletonCount = isMobile ? 6 : 9,
  maxColumns = null,
  skeletonWidth = null,
  skeletonHeight = null,
}) => {
  // Debug logging

  // If loading, create skeleton items
  if (isLoading) {
    const skeletonItems = Array.from({length: skeletonCount}, (_, index) => ({
      id: `skeleton-song-${index}`,
    }));

    const renderSkeletonSong = (item) => {
      return <SkeletonCard variant='song' width={skeletonWidth} height={skeletonHeight} />;
    };

    return (
      <DraggableTileGrid
        items={skeletonItems}
        onItemClick={() => {}} // No click action for skeleton
        title={title} // Keep the actual title even when loading
        itemsPerColumn={3}
        columnWidth={308}
        renderItem={renderSkeletonSong}
        className='songs-tile skeleton-loading'
        minColumnsInView={2}
        viewAllText=''
        onViewAllClick={() => {}}
        maxColumns={maxColumns}
        initialOffset={isMobile ? 18 : 0}
        slidesOffsetAfter={isMobile ? 18 : 0}
      />
    );
  }

  // Normal rendering
  // Removed debug logs
  const renderSong = (song) => {
    return <SongCardWithImageLoading song={song} onDownload={onDownload} skeletonWidth={skeletonWidth} skeletonHeight={skeletonHeight} />;
  };

  return (
    <DraggableTileGrid
      items={songs}
      onItemClick={onSongClick}
      title={title}
      itemsPerColumn={3}
      columnWidth={308}
      renderItem={renderSong}
      className='songs-tile'
      minColumnsInView={1}
      viewAllText={viewAllText}
      onViewAllClick={onViewAllClick}
      maxColumns={maxColumns}
      initialOffset={isMobile ? 18 : 0}
      slidesOffsetAfter={isMobile ? 100 : 0}
    />
  );
};

export default memo(SongsTile);
